// What the kiosk shell renders: the scanner and the two providers it needs.
// No auth bootstrap, no fleet or parts fetch, no navbar, no Flerpie, no Login.
// index.js chooses this over <App /> when inShell() is true.

import React from 'react';
import { ToastProvider } from '../components/Toast/ToastContext';
import { ConfirmProvider } from '../components/ConfirmModal/ConfirmContext';
import RootErrorBoundary from '../components/RootErrorBoundary';
import useScannerStore from '../stores/useScannerStore';
import { setTokenProvider } from '../apiHelpers';
import { shellTokens } from './shellTokens';
import { buzz } from './shell';
import ScannerMode from './ScannerMode';

let installed = false;

// Every scanner workflow reports a refused scan as an error toast, so this one hook covers them all.
export function buzzForToast(type: string) {
  if (type === 'error') buzz('reject');
  else if (type === 'warning') buzz('warn');
}

// Must run before ScannerMode's first request, and child effects run before the
// parent's, so this happens during render rather than in an effect.
function installShellTokens() {
  if (installed) return;
  installed = true;
  shellTokens.onOperatorExpired(() => useScannerStore.getState().clearOperator());
  setTokenProvider(shellTokens);
}

const ShellApp: React.FC = () => {
  installShellTokens();
  return (
    <ToastProvider onShow={buzzForToast}>
      <ConfirmProvider>
        <RootErrorBoundary>
          <ScannerMode />
        </RootErrorBoundary>
      </ConfirmProvider>
    </ToastProvider>
  );
};

export default ShellApp;
